// Footer.js
import React from 'react';

export default function Footer() {
  return (
    <div className="text-center text-muted py-3 bg-light">
      <div className="container">
        <div className="row">
          <div className="col-12">
            © {new Date().getFullYear()} Efraim Hdz. All rights reserved.
            <div className="mt-2">
              <small>Built with React & Bootstrap</small>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}